import styled from '@mui/system/styled';
import Flex from 'ui/Flex/Flex';
import { containerStyle } from 'components/SharedComponents/HighlightContainer/helpers';
import { Theme } from '@mui/material/styles';
import { BoxProps } from '@mui/material/Box';

const StyHighlightBox = styled(Flex, {
    name: 'StyHighlightBox',
})<{ color: keyof Theme['palette'] }>(({ theme, color }) => ({
    ...containerStyle,
    height: '100%',
    align: 'center',
    backgroundColor: theme.palette[color].background,
    display: 'flex',
}));
type Props = BoxProps & {
    color?: keyof Theme['palette'];
};
const HighlightBox = ({ children, color = 'primary', sx = {} }: Props) => {
    return (
        <StyHighlightBox color={color} sx={sx}>
            {children}
        </StyHighlightBox>
    );
};
export default HighlightBox;
